import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBars,
  FaUser,
  FaChevronDown,
  FaArrowLeft,
} from "react-icons/fa";
import { apiFetch } from "../api_call"; // ✅ import centralized API

export default function UserHeader({ menuOpen, setMenuOpen }) {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const dropdownRef = useRef(null);

  // ---------------- CHECK ADMIN ROLE ----------------
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        if (userData?.usrlst_role?.toLowerCase() === "admin") {
          setIsAdmin(true);
        }
      } catch (err) {
        console.error("Error parsing user data:", err);
      }
    }
  }, []);

  // ---------------- LOGOUT ----------------
  // ---------------- LOGOUT ----------------
const handleLogout = async () => {
  try {
    // 🔹 Just call logout API (JWT is enough)
    await apiFetch("/logout", "POST");
  } catch (error) {
    console.error("Logout API Error:", error);
  }

  // ✅ Clear frontend session
  localStorage.removeItem("user");
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("access_token"); // if you store token separately

  // ✅ Redirect to login
  navigate("/login");
};

  // ---------------- CLOSE DROPDOWN ON OUTSIDE CLICK ----------------
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="header">
      <div
  className="header-left"
  style={{ display: "flex", alignItems: "center", gap: "12px" }}
>
  <button class="btn" 
  onClick={() => navigate(-1)}
  style={{marginTop:'8px'
  }}>
  <FaArrowLeft
    className="back-icon"
    
    style={{
      cursor: "pointer",
      fontSize: "18px",
    }}
    title="Go Back"
  />
   Back
  </button>

  <FaBars
    className="hamburger-icon"
    onClick={() => setMenuOpen(!menuOpen)}
  />

  <div
    className="logo"
    onClick={() => navigate("/user_dashboard")}
    style={{ cursor: "pointer" }}
  >
    MCV - OverSight Manager
  </div>
</div>

      <div
        className="header-actions"
        style={{ position: "relative" }}
        ref={dropdownRef}
      >
        <button
  className="btn user-primary"
  onClick={() => setDropdownOpen(!dropdownOpen)}
  style={{ display: "flex", alignItems: "center", gap: "6px" }}
>
  <FaUser className="btnIcon" color="#fff" />
  <span>User</span>
  <FaChevronDown
    size={12}
    style={{
      transition: "transform 0.2s ease",
      transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
    }}
  />
</button>

        {dropdownOpen && (
          <div
            style={{
              position: "absolute",
              top: "110%",
              right: 0,
              background: "#fff",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              borderRadius: "6px",
              overflow: "hidden",
              zIndex: 1000,
              minWidth: "140px",
            }}
          >
            {/* ✅ Admin Button */}
            {isAdmin && (
              <button
                style={{
                  display: "block",
                  width: "100%",
                  padding: "8px 12px",
                  border: "none",
                  background: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
                onClick={() => navigate("/dashboard")}
              >
                Admin Dashboard
              </button>
            )}

            {/* ✅ Logout */}
            <button
              style={{
                display: "block",
                width: "100%",
                padding: "8px 12px",
                border: "none",
                background: "none",
                textAlign: "left",
                cursor: "pointer",
                fontSize: "14px",
              }}
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
